export const SawtoothUp = () => (
  <svg
    width="360"
    height="6"
    viewBox="0 0 360 6"
    fill="none"
    stroke="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M-14 0.272727C-13.1111 -0.0909093 -10.8889 -0.0909089 -10 0.272727L4 6H-28L-14 0.272727Z"
      fill="white"
    />
    <path
      d="M18 0.272727C18.8889 -0.0909093 21.1111 -0.0909089 22 0.272727L36 6H4L18 0.272727Z"
      fill="white"
    />
    <path
      d="M50 0.272727C50.8889 -0.0909093 53.1111 -0.0909089 54 0.272727L68 6H36L50 0.272727Z"
      fill="white"
    />
    <path
      d="M82 0.272727C82.8889 -0.0909093 85.1111 -0.0909089 86 0.272727L100 6H68L82 0.272727Z"
      fill="white"
    />
    <path
      d="M114 0.272727C114.889 -0.0909093 117.111 -0.0909089 118 0.272727L132 6H100L114 0.272727Z"
      fill="white"
    />
    <path
      d="M146 0.272727C146.889 -0.0909093 149.111 -0.0909089 150 0.272727L164 6H132L146 0.272727Z"
      fill="white"
    />
    <path
      d="M178 0.272727C178.889 -0.0909093 181.111 -0.0909089 182 0.272727L196 6H164L178 0.272727Z"
      fill="white"
    />
    <path
      d="M210 0.272727C210.889 -0.0909093 213.111 -0.0909089 214 0.272727L228 6H196L210 0.272727Z"
      fill="white"
    />
    <path
      d="M242 0.272727C242.889 -0.0909093 245.111 -0.0909089 246 0.272727L260 6H228L242 0.272727Z"
      fill="white"
    />
    <path
      d="M274 0.272727C274.889 -0.0909093 277.111 -0.0909089 278 0.272727L292 6H260L274 0.272727Z"
      fill="white"
    />
    <path
      d="M306 0.272727C306.889 -0.0909093 309.111 -0.0909089 310 0.272727L324 6H292L306 0.272727Z"
      fill="white"
    />
    <path
      d="M338 0.272727C338.889 -0.0909093 341.111 -0.0909089 342 0.272727L356 6H324L338 0.272727Z"
      fill="white"
    />
    <path
      d="M370 0.272727C370.889 -0.0909093 373.111 -0.0909089 374 0.272727L388 6H356L370 0.272727Z"
      fill="white"
    />
  </svg>
);
